import { brand, alpha } from '@/styles/shared';

export const microphoneSelectorStyles = {
  toggleButton: {
    position: 'absolute',
    bottom: -25,
    right: -25,
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
    padding: '6px 12px',
    color: '#fff',
    border: `1px solid ${alpha.purple12}`,
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '12px',
    background: brand.purpleAccentDark,
    fontFamily: 'Montserrat',
    fontWeight: 500,
    transition: 'all 0.2s ease',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.08)',
    '&:hover': {
      backgroundColor: alpha.purple05,
      borderColor: brand.purpleAccent,
      boxShadow: '0px 4px 12px rgba(102, 21, 149, 0.15)',
      color: brand.purpleAccentDark,
    },
  },

  container: {
    position: 'absolute',
    bottom: -25,
    right: -25,
    backgroundColor: '#FFFFFF',
    border: `1px solid ${alpha.purple12}`,
    borderRadius: '12px',
    padding: '12px',
    minWidth: 250,
    maxWidth: {
      xs: 'calc(100vw - 60px)',
      sm: 320,
    },
    boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.12)',
    zIndex: 1000,
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '8px',
  },

  title: {
    fontFamily: 'Montserrat',
    fontWeight: 600,
    fontSize: '13px',
    color: brand.purpleAccent,
  },

  closeButton: {
    padding: '4px',
    color: 'rgba(0, 0, 0, 0.5)',
    '&:hover': {
      backgroundColor: alpha.purple05,
      color: brand.purpleAccent,
    },
  },

  select: {
    fontFamily: 'Montserrat',
    color: 'rgba(0, 0, 0, 0.6)',
    fontSize: '13px',
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: alpha.purple12,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: brand.purpleAccent,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: brand.purpleAccent,
    },
  },
};
